import React from "react";
import "./advisory1.css";

const Advisory1 = ({ image, title }) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <img src={image} className="advisory-card" alt={title} />
    </div>
  );
};

export default Advisory1;
